/* eslint-disable react/prefer-es6-class, react/sort-comp, react/jsx-no-bind */
import React from 'react';
import Keys from 'es6/core/keys';
import { t } from 'es6/services/localization';
import FitText from 'es6/components/common/fit-text';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import * as SoundEffects from 'es6/core/sound-effects';
import SoundManager from 'es6/services/sound-manager';
import { TranscodedImageSizes, TranscodedImage } from 'es6/components/common/transcoded-image';

/**
 * ItemPackages are expected to contain the memory field.
 */
export default React.createClass({
  displayName: 'SentenceBuilderRecallScreen',

  propTypes: {
    mode: React.PropTypes.oneOf(['listening', 'reading']).isRequired,
    onDontKnow: React.PropTypes.func.isRequired,
    onNext: React.PropTypes.func.isRequired,
    sentence: React.PropTypes.object.isRequired,
  },

  /**
   * Bind keyboard events.
   */
  componentDidMount() {
    if (this.props.mode === 'listening') {
      this._playSound({
        finished: () => SoundManager.playEffect(SoundEffects.RECALL),
      });
    } else {
      SoundManager.playEffect(SoundEffects.RECALL);
    }

    document.addEventListener('keydown', this._handleKeydown);
  },

  /**
   * Unbind keyboard events.
   */
  componentWillUnmount() {
    SoundManager.stop();
    document.removeEventListener('keydown', this._handleKeydown);
  },

  /**
   * Callback for keydown event.
   *
   * @param {Event} e
   */
  _handleKeydown(e) {
    const downKey = e.shiftKey && e.keyCode === Keys.DOWN;
    const spaceKey = e.keyCode === Keys.SPACE;

    if (this.props.mode === 'listening' && (downKey || spaceKey)) {
      this._playSound();
    }
  },

  /**
   * Play the sentence sound.
   *
   * @param {Object} options
   */
  _playSound(options = {}) {
    const sound = this.props.sentence.sound;

    if (sound) {
      SoundManager.play(sound, options);
    }
  },

  render() {
    return (
      <div className="screen screen-sentence-builder-recall">
        <div className="screen-content">
          {this.props.mode === 'reading' ? this._renderReadingMode() : this._renderListeningMode()}
        </div>

        <Navigation>
          <NavButton align="left" onClick={this.props.onDontKnow} className="btn-danger">{t("don't know")}</NavButton>
          <NavButton align="right" onClick={this.props.onNext} focused>{t('js_iknow.next')}</NavButton>
        </Navigation>
      </div>
    );
  },

  _renderSentenceImage() {
    const image = this.props.sentence.getImage();

    if (!image) {
      return null;
    }

    return (
      <TranscodedImage size={TranscodedImageSizes.APP_SENTENCE} src={image} />
    );
  },

  _renderListeningMode() {
    return (
      <section className="mode-container listening-mode">
        <p className="message">{t('sentence-builder-recall-listening-instructions')}</p>

        <div className="sentence-study-figure">
          <section className="sentence-content">
            <div className="primary-content">
              <span className="sound-player glyph glyph-volume-medium sentence-sound" onClick={this._playSound.bind(null, {})} />
              {this._renderSentenceImage()}
            </div>
          </section>
        </div>
      </section>
    );
  },

  _renderReadingMode() {
    const translation = this.props.sentence.getTranslation();

    return (
      <section className="mode-container reading-mode">
        <p className="message">{t('sentence-builder-recall-reading-instructions')}</p>

        <div className="sentence-study-figure">
          <section className="sentence-content">
            <div className="primary-content">
              <div className="sentence-text">
                <FitText><span dangerouslySetInnerHTML={{ __html: translation }} /></FitText>
              </div>
            </div>

            <aside className="secondary-content">
              {this._renderSentenceImage()}
            </aside>
          </section>
        </div>
      </section>
    );
  },
});
